import Loader from './components/Loader'

export const KineticCSSLoader = () => (
  <div className='h-screen w-full flex justify-center items-center bg-[#2c3e50]'>
    <Loader />
  </div>
)
